app.service('checksBalancesService', function ($http) {

  // Routes -----------------------------------------
  
  this.getGoldWizardRecords = function (obj) {
    console.log('obj :>> ', obj);
    return $http.post('checksBalances/getGoldWizardRecords', obj)
      .then(function (response) {
        return response
      })
  }
  
  this.getHelloSignDocumentList = function (obj) {
    return $http.post('checksBalances/getHelloSignDocumentList', obj)
      .then(function (response) {
        return response
      })
  }
  //-------------------------------------------------

})